// FT-200 (REQ-11, CTR-03, U8): куда банк возвращает клиента после оплаты или привязки карты, начатых в кабинете.
//
// Возврат — страница результата кабинета `/client_page/result?flow=…&by=client&status=…`. Пары в адресе нет: вход
// берётся из вкладки (clientCabinetSession). `status` — только подсказка, итог страница берёт с сервера (REQ-11).
// Сервер принимает адрес, только если его origin в списке среды (ClientCabinet::ReturnUrls), иначе 422
// `return_url_not_allowed`.
//
// Origin:
//   - браузер — origin этой страницы (web.rentprog.ru, web.rentprog.com, stage.rentprog.ru): клиент возвращается туда,
//     откуда ушёл, и находит пару в той же вкладке;
//   - нативное приложение — всегда cabinet_origin компании из ответа (production — .ru/.com по компании, staging —
//     stage.rentprog.ru). Страница приложения живёт на https://rentprog.com (Android) или capacitor://rentprog.com
//     (iOS): банк туда вернуть не может, а сервер такой origin не примет.
//
// Модуль — часть «набора возврата» (Task 6): не тянет стор, роутер и компоненты кабинета.
import { Capacitor } from "@capacitor/core";

export const RESULT_PATH = "/client_page/result";

function nativePlatform() {
  try {
    return Capacitor.isNativePlatform();
  } catch (e) {
    return false;
  }
}

function pageOrigin() {
  try {
    return window.location.origin;
  } catch (e) {
    return null;
  }
}

function trimOrigin(value) {
  const origin = value === null || value === undefined ? "" : String(value).trim();
  return origin ? origin.replace(/\/+$/, "") : null;
}

// env — для спеков: { isNative, origin }; без него — платформа и origin этой страницы.
function base(company, env = {}) {
  const isNative = env.isNative !== undefined ? env.isNative : nativePlatform();
  if (isNative) return trimOrigin(company && company.cabinet_origin);
  return trimOrigin(env.origin !== undefined ? env.origin : pageOrigin());
}

// Адреса возврата для заказа у провайдера. Stripe берёт success_url и cancel_url, Yandex Pay — success_url,
// error_url и abort_url. null — origin неизвестен: тогда адреса не передаются и действует настройка компании.
function urls(flow, company, env = {}) {
  const root = base(company, env);
  if (!root) return null;
  const make = (status) => `${root}${RESULT_PATH}?flow=${encodeURIComponent(flow)}&by=client&status=${status}`;
  return {
    success_url: make("success"),
    cancel_url: make("fail"),
    error_url: make("fail"),
    abort_url: make("fail"),
  };
}

export default { RESULT_PATH, base, urls };
